import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom";
import Hero from './components/Hero';
import Text from './components/Text';
import Layout from './components/Layout';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import Colors from './components/Colors';
import Form from './components/Form';
import Popups from './components/Popups';
import Card from './components/Card';
import Button from './components/Button';
import Details from './components/Details';
import Tags from './components/Tags';
import Accordion from './components/Accordion';
import Margin from './components/Margin';
import Border from './components/Border';
import Home from './components/Home'
import Padding from './components/Padding';
import QuickStart from './components/QuickStart';
import Extras from "./components/Extras";
import { useState, useEffect } from "react";

function App() {
  const [goHome, setGoHome] = useState(true)
  const [col1, setCol1] = useState("col-10")
  const [col2, setCol2] = useState("col-10")

  useEffect(()=>{
    if(window.location.pathname !== '/'){
        setGoHome(false)
        setCol1("col-xl-2 col-lg-3 col-md-3 col-sm-10 col-xs-10")
        setCol2("xol=xl-8 col-lg-7 col-md-7 col-sm-10 col-xs-10")
    }
  },[setGoHome])

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/hero" element={<Hero />} />
        <Route path="/text" element={<Text />} />
        <Route path="/layout" element={<Layout />} />
        <Route path="/navbar" element={<Navbar />} />
        <Route path="/sidebar" element={<Sidebar />} />
        <Route path="/colors" element={<Colors />} />
        <Route path="/forms" element={<Form />} />
        <Route path="/popups" element={<Popups />} />
        <Route path="/cards" element={<Card />} />
        <Route path="/button" element={<Button />} />
        <Route path="/details" element={<Details />} />
        <Route path="/tags" element={<Tags />} />
        <Route path="/accordion" element={<Accordion />} />
        <Route path="/margin" element={<Margin />} />
        <Route path="/padding" element={<Padding />} />
        <Route path="/border" element={<Border />} />
        <Route path="/quickstart" element={<QuickStart />} />
        <Route path="/extras" element={<Extras />} />
        <Route path="/" element={<Home />} />
      </>
    )
  );

  return (
    <div className="App m-0">
      <div className="m-0 row">
      {!goHome?
        <div className={col1}>
            <div className="sidebar-collapse position-fixed">
              <div className="sidebar-head sidebar-bottom-border">
              <div className="sidebar-toogle-button" data-collapse="collapseSideBar"></div>
              <div className="navbrand"></div>
              </div>
              <div className="sidebar full-sidebar" id="collapseSideBar">
              <a href="/quickstart"><h3 className="m-0 p-0">Quick Start</h3></a>
              <a href="/"><h2 className="m-0 p-0">Documentation</h2></a>
              <a href="/hero">Hero</a>
              <a href="/text">Text Styling</a>
              <a href="/layout">Layout: Rows & Columns</a>
              <a href="/navbar">Navbar</a>
              <a href="/sidebar">Sidebar</a>
              <a href="/colors">Colors</a>
              <a href="/forms">Forms</a>
              <a href="/popups">Popups</a>
              <a href="/cards">Cards</a>
              <a href="/button">Buttons</a>
              <a href="/details">Details</a>
              <a href="/tags">Tags</a>
              <a href="/accordion">Accordion</a>
              <a href="/margin">Margins</a>
              <a href="/border"> Borders</a>
              <a href="/padding">Padding</a>
              <a href="/extras">Extra styles</a>

              <p className="mt-3 italic">© 2024</p>
            </div>
            </div>
        </div>: ""
      }
        <div className={col2}>
        <div className="m-1 px-1 c-dgrey">
        <RouterProvider router={router} />
        </div>
        </div>
      </div>      
    </div>
  );
}

export default App;
